import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'قائمة مرتبة',
  },
  az: {
    label: 'Sıralı Siyahı',
  },
  bg: {
    label: 'Подреден списък',
  },
  cs: {
    label: 'Seřazený seznam',
  },
  da: {
    label: 'Ordnet Liste',
  },
  de: {
    label: 'Geordnete Liste',
  },
  en: {
    label: 'Ordered List',
  },
  es: {
    label: 'Lista ordenada',
  },
  et: {
    label: 'Sorteeritud loend',
  },
  fa: {
    label: 'لیست مرتب شده',
  },
  fr: {
    label: 'Liste ordonnée',
  },
  he: {
    label: 'רשימה ממוינת',
  },
  hr: {
    label: 'Naručeni popis',
  },
  hu: {
    label: 'Rendelt lista',
  },
  is: {
    label: 'Raðaður listi',
  },
  it: {
    label: 'Elenco ordinato',
  },
  ja: {
    label: '順序付きリスト',
  },
  ko: {
    label: '주문된 목록',
  },
  my: {
    label: 'စီစဉ်ထားသော စာရင်း',
  },
  nb: {
    label: 'Ordnet Liste',
  },
  nl: {
    label: 'Geordende Lijst',
  },
  pl: {
    label: 'Uporządkowana lista',
  },
  pt: {
    label: 'Lista Ordenada',
  },
  ro: {
    label: 'Lista ordonată',
  },
  rs: {
    label: 'Уређена листа',
  },
  'rs-latin': {
    label: 'Uređena lista',
  },
  ru: {
    label: 'Упорядоченный список',
  },
  sk: {
    label: 'Zoradený zoznam',
  },
  sl: {
    label: 'Urejen seznam',
  },
  sv: {
    label: 'Ordnad Lista',
  },
  ta: {
    label: 'வரிசைப்படுத்தப்பட்ட பட்டியல்',
  },
  th: {
    label: 'รายการที่ถูกจัดลำดับ',
  },
  tr: {
    label: 'Sıralı Liste',
  },
  uk: {
    label: 'Впорядкований список',
  },
  vi: {
    label: 'Danh sách đã sắp xếp',
  },
  zh: {
    label: '有序列表',
  },
  'zh-TW': {
    label: '有序列表',
  },
}
